// Who is playing, on this page, right now (#123, #124).
//
// Module scope is the registry: the pack is imported once, so every controller that imports
// this shares these variables. No event bus, nothing on window.
//
// Two kinds of player talk to it:
//
//   * a standalone one (audio_preview_controller, the "Listen 30 s"/"Posłuchaj 30 s" CTA on a profile) owns
//     its own <audio> and only needs `claim`/`release` so that starting it stops anything else;
//   * the "teraz gra" bar (now_playing_controller) registers itself with `mountBar`, and from
//     then on it is the page's one media element. Cards are remotes: they call `play()` with a
//     src and a name instead of each carrying an <audio> of their own (#124, criterion 7).
//
// Because everything goes through here, "only one clip at a time" is a property of the page
// rather than a rule every controller has to remember.

let playing = null
let bar = null
const listeners = new Set()

// Called when an element starts playing - the only moment anything else has to give way.
export function claim(audio) {
  if (playing && playing !== audio) playing.pause()
  playing = audio
}

export function release(audio) {
  if (playing === audio) playing = null
}

// The bar --------------------------------------------------------------------------------

export function mountBar(controller) {
  bar = controller
}

export function unmountBar(controller) {
  if (bar === controller) bar = null
}

// A remote asks for a clip; the bar is the one with an element to play it on. A page without a
// bar has no remotes on it either, so this is a no-op there rather than a missing dependency.
export function play(source) {
  bar?.load(source)
}

export function stop() {
  bar?.stop()
}

// State ------------------------------------------------------------------------------------

// Remotes subscribe to find out whether they are the card that is playing, and how far along
// it is. Returns the unsubscribe, for disconnect().
export function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function publish(state) {
  listeners.forEach((listener) => listener(state))
}
